import { InjectionToken } from '@angular/core';
import { SupportedLanguage } from './supported-language';
import { Country } from './country';

export const ENV = new InjectionToken<BaseEnvironmentConfig>('env');

export interface BaseEnvironmentConfig {
  production: boolean;
  countries: Country[];
  isResidia: boolean;
  apiBaseUrl: string;
  apiBasicAuth: string;
  language: SupportedLanguage;
}
